import './resourceListHeader.scss'
import templateUrl from './resourceListHeader.html'

/**
 * Resource List header component.
 *
 * Transcluded inside a {@link tmrResourceList Resource List} component.
 *
 * @example
 * <tmr-resource-list-header
 *   page-size=""
 *   page-size-options="[25, 50, 100, 250]"
 *   on-page-size-change=""
 * ></tmr-resource-list-header>
 *
 * @type {ngComponent}
 * @prop {number} page-size
 * @prop {array<number>=} [page-size-options=[25, 50, 100, 250]]
 * @prop {function} on-page-size-change
 * @prop {boolean|string} pager If false, the pager is omitted. Routes with multiple pagers (that is: with an array as value of the `route.pager` option) may pass a string that will be used as pager id
 * @prop {number}  resources-count   The total number results
 */
export const tmrResourceListHeader = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrResourceListHeaderController',
  require: {
    resourceList: '^tmrResourceList',
  },
  bindings: {
    pageSize: '<',
    pageSizeOptions: '<?',
    onPageSizeChange: '&',
    pager: '<',
    resourcesCount: '<',
  },
}

export class tmrResourceListHeaderController {
  static ngType = 'controller'

  $onInit() {
    this.pageSizeOptions = this.pageSizeOptions ?? [25, 50, 100, 250]
  }
}
